const MuiCard = () => ({
});

export default MuiCard;
